import React, { useCallback } from 'react';

import { useCodeEditor } from '../CodeEditor/context';

const tip = {
  is_email_valid: <em>(true|false)</em>,
  is_phone_valid: <em>(true|false)</em>,
  is_postal_valid: <em>(true|false)</em>,
  is_fraud: <em>(true|false)</em>,
  is_bot: <em>(true|false)</em>,
  dob_yyyyddmm: <em>(Format: yyyyddmm)</em>,
  dob_slashes_mmddyyyy: <em>(Format: mm/dd/yyyy)</em>,
  dob_dashes_mmddyyyy: <em>(Format: mm-dd-yyyy)</em>,
  pe_key: <b><i>*required</i></b>
}

export default function PageVariables({ fields, toggle }) {
  const { editorsRef, activeEditor } = useCodeEditor()

  const handleClickLink = useCallback(value => {
    const editor = activeEditor ? editorsRef.current[activeEditor] : Object.values(editorsRef?.current || {})[0]
    editor && editor.setValue(editor.getValue() + value)
    toggle()
  }, [editorsRef, activeEditor, toggle]);

  return <div>
    <h3>Page Variables</h3>
    <p>
      Variables can be included in the Content field and when rendered to the client, they will be replaced with user-specific data. The supported fields are shown below. You can append "_urlencoded", "_jsescape" or "_md5" to any variable below that has (<b>encodable</b>), (<b>escapable</b>) or (<b>md5</b>) detailed on it.
    </p>
    <ul>
      {fields.map(([field, opts], index) => {
        return <li key={index}>
          <span className="btn-link text-secondary" style={{ cursor: 'pointer' }} onClick={() => handleClickLink(`{${field}}`)} ><b>{`{${field}}`}</b></span>
          {' '}{tip[field]}
          {' '}{opts.encodable ? <em className="btn-link text-secondary" style={{ cursor: 'pointer' }} onClick={() => handleClickLink(`{${field}_urlencoded}`)} >(encodable)</em> : null}
          {' '}{opts.dba ? <em className="btn-link text-secondary" style={{ cursor: 'pointer' }} onClick={() => handleClickLink(`{${field}_dba}`)} >(dba)</em> : null}
          {' '}{opts.bid ? <em className="btn-link text-secondary" style={{ cursor: 'pointer' }} onClick={() => handleClickLink(`{${field}_bid}`)} >(bid)</em> : null}
          {' '}{opts.bidid ? <em className="btn-link text-secondary" style={{ cursor: 'pointer' }} onClick={() => handleClickLink(`{${field}_tcpaconsent}`)} >(tcpaconsent)</em> : null}
          {' '}{opts.escapable ? <em className="btn-link text-secondary" style={{ cursor: 'pointer' }} onClick={() => handleClickLink(`{${field}_jsescape}`)} >(escapable)</em> : null}
          {' '}{opts.md5 ? <em className="btn-link text-secondary" style={{ cursor: 'pointer' }} onClick={() => handleClickLink(`{${field}_md5}`)} >(md5)</em> : null}
          {' '}{opts.optout ? <em className="btn-link text-secondary" style={{ cursor: 'pointer' }} onClick={() => handleClickLink(`{${field}_optout}`)} >(optout)</em> : null}
        </li>
      })}
    </ul>
    <p>
      A note about pid, sid1, and sid2: These values are set when the user lands on the landing page (or voucher page). They are set
      from the values specified in the URL, but are optional. Once set from the incoming URL, they are stored in the cookie in the
      user's browser and persisited across requests throughout the path. If a pid, sid1, or sid2 is found in the URL, request body,
      or the user's cookie, they will be made available as template variables above. If there is no pid, sid1, or sid2, then this value
      will be an empty string.
      </p>
  </div>
}
PageVariables.defaultProps = {
  fields: []
}
